import { stringify } from "query-string"

import { farasodInstagram } from "./api"

export const loginToInstagramAccount = async (queries) => {
  const query =
    stringify(queries, {
      skipEmptyString: true,
      skipNull: true
    })

  const response =
    await farasodInstagram.get(`/instagram/auth/start?${query}`)

  return response.data
}

export const deactiveFromInstagramAccount = async (data) => {
  const response =
    await farasodInstagram.patch(`/instagram/disconnect`, data)

  return response.data
}

export const reactiveFromInstagramAccount = async (data) => {
  const response =
    await farasodInstagram.patch(`/instagram/reactive`, data)

  return response.data
}

export const checkInstagramAccount = async (contractId) => {
  const response =
    await farasodInstagram.get(`/instagram/contract/${contractId}`)

  return response.data
}